<div mat-dialog-title class="app-dialog-title" i18n="@@forgot-password-popup-title|Forgot password popup title">
	Recuperar contraseña
	<button mat-icon-button class="close-button" (click)="close()">
		<mat-icon>cancel</mat-icon>
	</button>
</div>
<mat-dialog-content class="dialog-content">
	<p class="app-dialog-content-title" i18n="@@forgot-password-popup-prompt|Forgot password prompt for email">
		Introduce tu email:
	</p>
	<form [formGroup]="form" (ngSubmit)="passwordResetToken()">
		<div class="form-content">
			<mat-form-field floatLabel="auto">
				<input matInput i18n-placeholder="@@forgot-password-popup-email-placeholder|Email field placeholder" type="email" placeholder="Email" name="email" formControlName="email" appInputEmptyToNull required autocomplete="username">
			</mat-form-field>
			<app-form-message [serverError]="serverError()" [serverResponse]="serverResponse()"></app-form-message>
			<button type="submit" mat-raised-button [disabled]="!submitButtonActive()" class="submit-button app-primary-background" i18n="@@forgot-password-popup-submit|Submit button label">Enviar</button>
		</div>
	</form>
	<mat-divider></mat-divider>
	<a href="{{environment.apiServer.url}}/api/authentication/login-google">
		<button mat-fab extended [disabled]="!submitButtonActive()" class="submit-button app-surface-container app-elevation0 login-phone-button" i18n="@@forgot-password-popup-google-login|Login with Google button label">
			<mat-icon>
				<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
					<path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
					<path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
					<path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
					<path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
				</svg>
			</mat-icon>
			Iniciar sesión con Google
		</button>
	</a>
	<a [routerLink]="['/login-phone']" (click)="close(true)">
		<button mat-fab extended [disabled]="!submitButtonActive()" class="submit-button app-surface-container app-elevation0 login-phone-button" i18n="@@forgot-password-popup-phone-login|Login with phone button label">
			<mat-icon>call</mat-icon>
			Iniciar sesión con teléfono
		</button>
	</a>
	<mat-divider></mat-divider>
	<span i18n="@@forgot-password-popup-new-customer|New customer prompt with signup link">Nuevo cliente? <a [routerLink]="['/signup']" (click)="close(true)">Crear cuenta</a></span>
	<span i18n="@@forgot-password-popup-has-account|Existing account prompt with login link">Ya tienes una cuenta? <a [routerLink]="['/login']" (click)="close(true)">Entra aquí</a></span>
	<span class="legal-consent" i18n="@@auth-legal-consent|Consent notice shown under the sign-in options">Al continuar aceptas nuestros <a [routerLink]="['/terms-of-use']" (click)="close(true)">Términos de uso</a> y nuestra <a [routerLink]="['/privacy-policy']" (click)="close(true)">Política de privacidad</a>.</span>
</mat-dialog-content>
